export default "__VITE_ASSET__61abdf54__"